import * as React from "react";
import { forwardRef } from "react";
const SvgAddIconBlue = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", id: "Layer_1", viewBox: "0 0 40 40", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("style", null, ".cls-1{fill:#fff;}")), /* @__PURE__ */ React.createElement("path", { className: "cls-1", d: "M39,19H21V1C21,.45,20.55,0,20,0s-1,.45-1,1V19H1C.45,19,0,19.45,0,20s.45,1,1,1H19v18c0,.55,.45,1,1,1s1-.45,1-1V21h18c.55,0,1-.45,1-1s-.45-1-1-1Z" }));
const ForwardRef = forwardRef(SvgAddIconBlue);
export { ForwardRef as ReactComponent };
